<script lang="ts">
  import SearchBar from './SearchBar.svelte';
  import ThreePanelGrid from './ThreePanelGrid.svelte';
  import TimelinePanel from './TimelinePanel.svelte';
  import ExecutionDetailPanel from './ExecutionDetailPanel.svelte';
  import AgentChatPanel from './AgentChatPanel.svelte';
  import { selectedEvent, searchState } from '../stores/debugger-timeline';
  import { loadExecution } from '../stores/execution-detail';
  import { currentTheme, applyTheme } from '../stores/theme';
  import { goHome } from '../stores/router';
  import { animate, stagger } from 'motion';
  import { onMount } from 'svelte';

  let pageEl: HTMLDivElement | undefined = $state();
  let chatOpen = $state(false);

  onMount(() => {
    if (pageEl) {
      const panels = pageEl.querySelectorAll('[data-panel]');
      if (panels.length > 0) {
        animate(Array.from(panels), { opacity: [0, 1], x: [-20, 0] }, { duration: 0.5, delay: stagger(0.12), ease: 'easeOut' });
      }
    }
  });

  $effect(() => {
    applyTheme($currentTheme);
  });

  $effect(() => {
    const event = $selectedEvent;
    if (event?.executionId) {
      loadExecution(event.executionId, $searchState.environment);
    }
  });
</script>

<div bind:this={pageEl} class="min-h-screen bg-bg-dark text-text-primary font-sans">
  <SearchBar />
  <ThreePanelGrid bind:chatOpen>
    {#snippet timeline()}
      <TimelinePanel />
    {/snippet}
    {#snippet detail()}
      <ExecutionDetailPanel />
    {/snippet}
    {#snippet chat()}
      <AgentChatPanel onclose={() => chatOpen = false} />
    {/snippet}
  </ThreePanelGrid>
</div>
